import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataService } from '../../../../../../services/dashboard/data.service';
import { CustomDateFormatPipe } from '../../../../../../pipes/custom-date-format.pipe';
import { HospitalTitlecasePipe } from "../../../../../../pipes/hospital-titlecase.pipe";

@Component({
  selector: 'app-modal-evolution-regional-economia',
  standalone: true,
  imports: [CommonModule, CustomDateFormatPipe, HospitalTitlecasePipe],
  templateUrl: './modal-evolution-regional-economia.component.html',
  styleUrl: './modal-evolution-regional-economia.component.css'
})
export class ModalEvolutionRegionalEconomiaComponent   implements OnInit, OnDestroy
{
  @Output() isModalOpen = new EventEmitter<boolean>();
  @Input() allInfo: any = {};

  Regioni: any[] = [];
  medicineId: number = 0;
  countryId: number = 1; // Default to Italy
  isLoading: boolean = true;

  constructor(private dataService: DataService) {}

  ngOnInit() {
    document.body.style.overflow = 'hidden';
    document.body.style.width = '100%';
  }

  ngOnDestroy() {
    document.body.style.overflow = '';
    document.body.style.width = '';
  }

  closeModal() {
    this.isModalOpen.emit(false);
  }

  formatDateForDatepicker(dateString: string): string | null {
    if (!dateString) return null;

    // If already in dd/mm/yyyy, return as-is
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
      return dateString;
    }

    let day: string, month: string, year: string;

    if (/^\d{8}$/.test(dateString)) {
      // Format: DDMMYYYY
      day = dateString.slice(0, 2);
      month = dateString.slice(2, 4);
      year = dateString.slice(4, 8);
    } else {
      console.warn('Invalid date format:', dateString);
      return null;
    }

    return `${day}/${month}/${year}`;
  }
}
